import { render, staticRenderFns } from "./StepDotationNature.vue?vue&type=template&id=1bce106c&scoped=true&"
import script from "./StepDotationNature.vue?vue&type=script&lang=ts&"
export * from "./StepDotationNature.vue?vue&type=script&lang=ts&"
import style0 from "./StepDotationNature.vue?vue&type=style&index=0&id=1bce106c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bce106c",
  null
  
)

export default component.exports